import {
  type ImageBehavior,
  type ImageRatio,
  type TileSelectorModes,
} from '@blaze-shared/elements-domain';
import { type SelectOption } from '@blaze-shared/shared-util';

export const TILE_SELECTOR_IMAGE_RATIOS: SelectOption<ImageRatio>[] = [
  { value: 'none', label: 'Unrestricted' },
  { value: '1:1', label: 'Square (1:1)' },
  { value: 'circle', label: 'Circle' },
  { value: '16:9', label: 'Landscape L (16:9)' },
  { value: '4:3', label: 'Landscape S (4:3)' },
  { value: '9:16', label: 'Portrait L (9:16)' },
  { value: '3:4', label: 'Portrait S (3:4)' },
];

export interface TileSelectorProps {
  mode?: TileSelectorModes;
  image?: {
    width: string;
    height: string;
    ratio: ImageRatio;
    behavior: ImageBehavior;
    position: 'left' | 'top' | 'bottom';
  };
}
